<template>
  <NavigationMobileLayout :navItems="navItems" />
</template>

<script setup>
import { computed } from 'vue';
import { useShaftOperationTypeNavItems } from '@/functions/operation_type_nav_items';

// Components
import NavigationMobileLayout from '@/components/operations/operation_type_navigation_mobile_layout.vue';

const props = defineProps({
  /** Show/hide HME options in the navigation */
  showHmePolicy: { type: Boolean, required: false, default: false },
});

const { getNavigationItems } = useShaftOperationTypeNavItems();

const navItems = computed(() => {
  return getNavigationItems(props.showHmePolicy);
});
</script>
